

import React, { Component } from 'react';
import { withRouter } from './withRouter.js';

class LabName extends Component {



    constructor(props) {
        super(props);
    }


    componentDidMount() {
        // this.createVis()
    }

    componentDidUpdate() {
        // this.createVis();
    }




    render() {
        return (
            <font>
            FIGX
            </font>
        )
    }

}


export default LabName;